import * as React from "react";
import AdminApprovalView from "./components/AdminApprovalView";

export default function AdminApprovalViewPage() {
    return (
    <>
      <AdminApprovalView />
    </>
  );
}